var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8117",
    "data-name": "Group 8117",
    transform: "translate(-192 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    d: "M0,0H30V30H0Z",
    transform: "translate(192 312)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(194.5 312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11620",
    "data-name": "Path 11620",
    d: "M21.2,0H37.135l8.444,8.411V28.125A1.875,1.875,0,0,1,43.7,30H21.2a1.875,1.875,0,0,1-1.875-1.875V1.875A1.875,1.875,0,0,1,21.2,0Z",
    transform: "translate(-19.329)",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11621",
    "data-name": "Path 11621",
    d: "M211.367,8.612h-6.535a1.876,1.876,0,0,1-1.875-1.875V.193Z",
    transform: "translate(-185.145 -0.174)",
    fill: "#b53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11622",
    "data-name": "Path 11622",
    d: "M99.723,136.5a.545.545,0,0,0,0-1.079H97.934a.559.559,0,0,0-.545.609v4.4c0,.392.223.609.525.609s.524-.218.524-.609v-1.207H99.52a.508.508,0,0,0,.5-.548.5.5,0,0,0-.5-.533H98.438V136.5Zm-6.046-1.079H92.368a.579.579,0,0,0-.608.606v4.4a.577.577,0,0,0,.622.59h1.373a2.547,2.547,0,0,0,2.7-2.721A2.614,2.614,0,0,0,93.677,135.42Zm.063,4.513h-.8v-3.428h.719c1.088,0,1.562.73,1.562,1.738C95.223,139.187,94.758,139.933,93.74,139.933Zm-4.794-4.513h-1.3a.545.545,0,0,0-.571.609v4.4a.552.552,0,1,0,1.1,0v-1.283h.813a1.775,1.775,0,0,0,1.831-1.853A1.8,1.8,0,0,0,88.945,135.42Zm-.022,2.691h-.747v-1.658h.747a.833.833,0,0,1,0,1.658Z",
    transform: "translate(-80.506 -122.284)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.08c4d66cbdd4421eb04930e100783663.svg";
export { ForwardRef as ReactComponent };